import React from "react";
import { createPortal } from "react-dom";
import { Responsive, WidthProvider } from "react-grid-layout";
import './ChartDashboardViewr.css';
import { ReactComponent as HandIcon } from '../icons/hand.svg';
import { ReactComponent as SideDashFilters } from '../icons/filters.svg';
import { ReactComponent as SideDashChart } from '../icons/sideDashChart.svg';
import { ReactComponent as SideDashHeading } from '../icons/sideDashHeading.svg';
import { ReactComponent as SideDashPalette } from '../icons/sideDashPalette.svg';
import { ReactComponent as SideDashUp } from '../icons/sideDashUp.svg';
import { ReactComponent as SideDashDown } from '../icons/sideDashDown.svg';

import { ReactComponent as EditIcon } from '../icons/dashboard/edit.svg';
import { ReactComponent as LockIcon } from '../icons/dashboard/lock.svg';
import { ReactComponent as UnlockIcon } from '../icons/dashboard/unlock.svg';
import axios from 'axios';
import { API_BASE_URL, saveWidgetThemeToDatabase, ChartWidget, fetchData, WidgetPlaceholder, renderAutoSaveModal} from './Common';

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const themeMap = {
  1: {
    name: 'Sem Cor',
    backgroundColor: '#FFFFFF',
    border: '2px dashed #E6E9F0',
    color: '#233A80'
  },
  2: {
    name: 'Branco',
    backgroundColor: '#FFFFFF',
    border: '2px solid #E6E9F0',
    color: '#233A80'
  },
  3: {
    name: 'Verde',
    backgroundColor: '#EDFAF3',
    border: '2px solid #43C97F',
    color: '#233A80'
  },
  4: {
    name: 'Azul',
    backgroundColor: '#EEF0F5',
    border: '2px solid #233A80',
    color: '#233A80'
  },
  5: {
    name: 'Vermelho',
    backgroundColor: '#FDF2F6',
    border: '2px solid #E5004E',
    color: '#233A80'
  },
  6: {
    name: 'Amarelo',
    backgroundColor: '#FEFDF7',
    border: '2px solid #F7BE04',
    color: '#233A80'
  }
};

export default class DragFromOutsideLayout extends React.Component {

  static defaultProps = {
    className: "layout",
    //rowHeight: 300,
    onLayoutChange: function() {},
    //cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
  };

  state = {
    widgetDropdownsOpen: {}, // Track open/closed state per widget
    lastClickedWidgetId: null,
    isDragging: false,
    currentBreakpoint: "lg",
    compactType: "horizontal",
    mounted: false,
    layouts: { lg: generateLayout(WidgetsData(this.props.dashboard, this.props.widgets)) },
    widgets_data: WidgetsData(this.props.dashboard, this.props.widgets),//trigger generateLayout rerender on change
    isDraggable: false,
    selectedWidgetIds: [],
    filteredData: this.props.tableColumnData,
    dropdownSelections: {},
    stateWidgets:this.props.widgets,
    isConfirmationModalOpen: !localStorage.getItem("seenAutoSaveModal")
  };

  componentDidMount() {
    this.setState({ mounted: true});
    const { dashboard } = this.props;
    document.addEventListener("click", this.handleClickOutside);
}

  componentWillUnmount() {
  document.removeEventListener("click", this.handleClickOutside);
}

  handleClickOutside = (event) => {
  // Only proceed if any dropdown is open
  if (!Object.values(this.state.widgetDropdownsOpen).some(v => v)) return;

  // Check if click was inside any dropdown
  const clickedInsideDropdown = event.target.closest('.edit-widget-popup') || event.target.closest('.edit-button1');

  if (!clickedInsideDropdown) {
    // Close all dropdowns
    this.setState({ widgetDropdownsOpen: {} });
  }
};

/*
componentDidUpdate(prevProps) {
  if (
    prevProps.dashboard !== this.props.dashboard ||
    prevProps.widgets !== this.props.widgets
  ) {
    const widgets_data = WidgetsData(this.props.dashboard, this.props.widgets);
    this.setState({
      widgets_data,
      layouts: { lg: generateLayout(widgets_data) },
      stateWidgets: this.props.widgets,
    });
  }
}
*/

  generateDOM(nonElementWidgets) {
    return Object.keys(this.state.widgets_data).map(widgetId => {
      const widget = this.state.widgets_data[widgetId];
      const widgetKey = Object.keys(widget)[0];

      const isElementWidget = [100, 101, 102, 103, 104].includes(Number(widget[widgetKey].graph_type));

      return (
        <div key={widgetId} className={widget.static ? "static" : ""}
        onClick={() => {
    this.setState({ lastClickedWidgetId: widgetId });
  }}
  >

<div className="widget-container1"

style={getWidgetStyle(
  widgetId,
  this.state.lastClickedWidgetId,
  Object.fromEntries(
    this.props.dashboard.widgets.map(w => [w.widget_id, w.theme])
  ),
  this.props.permission
)}
>
<div className="widget-header">
            <span className="widget-title1">
            {widget[widgetKey].name.toString()}</span>
            {((this.props.permission !== "read-only") && (this.props.permission !== "URL")) && (
  <>
    {/* Edit/Change button */}
    {!isElementWidget  && (
    <button
  onClick={(e) => {
    e.stopPropagation();

    const rect = e.currentTarget.getBoundingClientRect();

    this.popupPosition = {
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX
    };

    this.setState(prevState => ({
      widgetDropdownsOpen: {
        [widgetId]: !prevState.widgetDropdownsOpen[widgetId],
      }
    }));
  }}
  className="edit-button1"
>
  <EditIcon />
</button>

    )}

    {/* Delete button */}
    <button
      onClick={(e) => {
        e.stopPropagation();
        this.handleDelete(widgetId);
      }}
      className="delete-button1"
      aria-label="Remover widget"
    >
      ✕
    </button>

    {/* Dropdown for replacing widget */}
    {this.state.widgetDropdownsOpen[widgetId] &&
 Object.entries(nonElementWidgets).length > 0 &&
 createPortal(
   <div
     className="edit-widget-popup"
     style={{
       position: "absolute",
       top: this.popupPosition?.top ?? 0,
       left: this.popupPosition?.left ?? 0
     }}
   >
     {Object.entries(nonElementWidgets).map(([id, widget]) => (
       <div
         key={id}
         className="edit-widget-popup-item"
         onClick={() => {
           this.handlePlaceholderSelect(id, widgetId);
           this.setState(prevState => ({
             widgetDropdownsOpen: {
               ...prevState.widgetDropdownsOpen,
               [widgetId]: false
             }
           }));
         }}
       >
         {widget.name || `Widget ${id}`}
       </div>
     ))}
   </div>,
   document.body
 )}


  </>
)}


</div>

<div className="widget-body">
{widget[widgetKey].graph_type === 104 ? (
  <WidgetPlaceholder
    data={widget[widgetKey].conteudo}
    id={widgetId}
    paletteWidgets={nonElementWidgets}
    onSelectWidget={this.handlePlaceholderSelect}
  />
) : (
  <ChartWidget
    Id={widgetId}
    tableColumnData={this.state.filteredData}
    widget={widget}
    height={'100%'}
    tables={this.props.tables}
  />
)}
</div>

            </div>
        </div>
      );
    });
  }

  handlePlaceholderSelect = async (selectedWidgetId, placeholderId) => {
  try {
    const placeholderLayout = this.state.layouts.lg.find(
      l => l.i === placeholderId
    );

    const updatedWidgetsData = {
      ...this.state.widgets_data,
      [selectedWidgetId]: {
      widget_id: {
        ...this.state.stateWidgets[selectedWidgetId],
        x: placeholderLayout.x,
        y: placeholderLayout.y,
        w: placeholderLayout.w,
        h: placeholderLayout.h
      }
    }
    };

    delete updatedWidgetsData[placeholderId];

    // 5️⃣ Update layout (replace placeholder i with widget id)
    const updatedLayouts = {
      ...this.state.layouts,
      lg: this.state.layouts.lg.map(item =>
        item.i === placeholderId
          ? { ...item, i: selectedWidgetId }
          : item
      )
    };

    // 6️⃣ Remove widget from palette
    const updatedStateWidgets = { ...this.state.stateWidgets };
    delete updatedStateWidgets[selectedWidgetId];

    // 7️⃣ Update React state first (UI stays instant)
    this.setState({
      widgets_data: updatedWidgetsData,
      layouts: updatedLayouts,
      stateWidgets: updatedStateWidgets
    });

    await this.updateDatabase(updatedLayouts.lg);

    // 9️⃣ 🔥 DELETE placeholder widget from DB
    await axios.delete(`${API_BASE_URL}/widgets/${placeholderId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });

  } catch (error) {
    console.error('Error replacing placeholder widget:', error);
  }
};

  onBreakpointChange = breakpoint => {
    this.setState({
      currentBreakpoint: breakpoint
    });
  };

  onCompactTypeChange = () => {
    const { compactType: oldCompactType } = this.state;
    const compactType =
      oldCompactType === "horizontal"
        ? "vertical"
        : oldCompactType === "vertical"
        ? null
        : "horizontal";
    this.setState({ compactType });
  };


onLayoutChange = (layout, layouts) => {
    if (!this.state.isDragging) {
    this.props.onLayoutChange(layout, layouts);
    this.updateDatabase(layout);
    }
  };

handleDelete = async (widgetId) => {
  // Remove widget from state
  const newLayouts = { ...this.state.layouts };
  Object.keys(newLayouts).forEach(breakpoint => {
    newLayouts[breakpoint] = newLayouts[breakpoint].filter(layout => layout.i !== widgetId);
  });

  const newWidgetsData = { ...this.state.widgets_data };
  delete newWidgetsData[widgetId];

  this.setState({
    layouts: newLayouts,
    widgets_data: newWidgetsData,
  });

  const { DashboardId } = this.props;
  const token = localStorage.getItem('token');

  try {
    let response;

    if (this.state.stateWidgets[widgetId].label_id === 0) {
      // Use the DELETE endpoint when label_id is 0
      response = await axios.delete(`${API_BASE_URL}/widgets/${widgetId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
    } else {
      // Default POST endpoint when label_id is not 0
      response = await axios.post(`${API_BASE_URL}/delete-element`,
        { widgetId, DashboardId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
    }

    console.log('Element deleted successfully:', response.data);
  } catch (error) {
    console.error('Error deleting element:', error);
  }
};

updateDatabase = async (layout) => {   console.log(layout);
  const { DashboardId} = this.props;

  try {
    const token = localStorage.getItem('token');
    await axios.post(`${API_BASE_URL}/update-layout`, { layout, DashboardId }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    fetchData(`${API_BASE_URL}/widgets/${this.props.projectId}`, this.props.setWidgets, this.props.setIsWidgetsLoaded, 'widgetData');

    fetchData(
  `${API_BASE_URL}/dashboards/${this.props.projectId}`,
  this.props.setDashboards,
  this.props.setIsDashboardsLoaded,
  'dashboardData'
).then(() => {
});
} catch (error) {
}
};

handleCreateElement = async (graphType, conteudo) => {
  try {
    const token = localStorage.getItem('token');

const newWidgetData = {
      projectId: this.props.projectId,
      graphType: graphType,
      conteudo: conteudo,
      label: '0',
      name: "",
      dataset: null
    };

    const response = await axios.post(`${API_BASE_URL}/widgets`, newWidgetData, {
      headers: {
        Authorization: `Bearer ${token}` // Include JWT token in Authorization header
      }
    });

    const widget_id = Object.keys(response.data.duplicatedWidget)[0];

    return widget_id;
  } catch (error) {
    return null;
  }
};

onDrop = (layout, layoutItem, _event) => {

  const elementType = _event.dataTransfer.getData('elementType');
  const widgetId = _event.dataTransfer.getData('widget_id');

  // Only allow drops for known widget elements
  if (!widgetId && !['Imagem','Parágrafo','Título','Subtitulo'].includes(elementType)) {
    console.log("Dropped an invalid element, ignoring");
    return; // Ignore all other drops
  }

    const convertWidgetsDataToArray = (widgets_data) => {
        return Object.keys(widgets_data).map(key => {
            const widgetDetails = widgets_data[key].widget_id; // Accessing the widget_id object
            return {
                widget_id: key,  // Use the key as widget_id
                x: widgetDetails.x,
                y: widgetDetails.y,
                w: widgetDetails.w,
                h: widgetDetails.h,
            };
        });
    };

    const createNewWidget = (widget_id, layoutItem) => {
        return {
            widget_id: widget_id,
            x: layoutItem.x,
            y: layoutItem.y,
            w: layoutItem.w,
            h: layoutItem.h,
        };
    };

    const handleWidgetCreation = (widgetData, conteudo, graph_type) => {
        const updatedDashboard = {
            ...this.props.dashboard,
            widgets: [...convertWidgetsDataToArray(this.state.widgets_data), widgetData],  // Add the new widget
        };

        let combinedWidgets;

if (conteudo) {
combinedWidgets = {
    ...this.state.stateWidgets, // Spread operator to copy existing widgets
    [widgetData.widget_id]: {   // New entry for widgetData
        "label_id": 0,
        "name": "",
        "graph_type": graph_type, // Assuming the graph_type is a unique identifier
        "columns": [null],
        "conteudo": conteudo,
        "permission": null
    }
};
    } else combinedWidgets = this.state.stateWidgets;

        const updatedWidgetsData = WidgetsData(updatedDashboard, combinedWidgets);

        const updatedLayouts = generateLayout(updatedWidgetsData);

        this.updateDatabase(updatedLayouts);

        this.setState(
            {
                layouts: { ...this.state.layouts, lg: updatedLayouts }, // update layouts
                widgets_data: updatedWidgetsData, // also update widgets_data
                stateWidgets: combinedWidgets,
            },
            () => {
                // This callback will be called after the state has been updated
                this.setState({ isDragging: false }); // Now you can set isDragging to false
            }
        );
    };

    let widget_id;

    const elementTypes = ['Imagem', 'Parágrafo', 'Título', 'Subtitulo'];
    if (elementTypes.includes(_event.dataTransfer.getData('elementType'))) {
        let graph_type, conteudo;

        switch (_event.dataTransfer.getData('elementType')) {
            case 'Imagem':
                graph_type = '102';
                conteudo = 'images/prochild.png';
                break;
            case 'Parágrafo':
                graph_type = '101';
                conteudo = 'Parágrafo';
                break;
            case 'Título':
                graph_type = '100';
                conteudo = 'Título';
                break;
            case 'Subtitulo':
                graph_type = '103';
                conteudo = 'Subtitulo';
                break;
            default:
                return; // Exit if no valid type
        }

        this.handleCreateElement(graph_type, conteudo)
            .then((widget_id) => {
                const newWidget = createNewWidget(widget_id, layoutItem);
                handleWidgetCreation(newWidget, conteudo, graph_type);
            })
            .catch((error) => {
                console.error('Error creating widget:', error);
            });
    } else {
        widget_id = _event.dataTransfer.getData('widget_id');
        const newWidget = createNewWidget(widget_id, layoutItem);
        handleWidgetCreation(newWidget, null, null);
    }
};

onDropDragOver = (event) => {
  return { w: 3, h: 5 };  // Set the placeholder to 3x5 during drag
};

  render() {
    const { tables, dashboard, widgets, permission, tableColumnData } = this.props;

function filterTableData(columnId, selectedValue, datatoFilter) {
    const colunas = getColumnIds([Number(columnId)]);
    const newFilteredData = {};

    // Step 1: Find matching row indices based on selectedValue in the specified columnId
    const matchingIndices = datatoFilter[Number(columnId)].data.reduce((indices, value, index) => {
        if (value === selectedValue) {
            indices.push(index);
        }
        return indices;
    }, []);

    // Step 2: Filter the relevant columns in colunas
    colunas.forEach((id) => {
        if (datatoFilter[id]) {
            const columnData = datatoFilter[id];
            // Create a new entry in newFilteredData for each filtered column
            newFilteredData[id] = {
                column_name: columnData.column_name,
                data: matchingIndices.map(index => columnData.data[index]),
                row_id: matchingIndices.map(index => columnData.row_id[index]),
            };
        }
    });

    // Step 3: Include all other columns not in colunas unfiltered
    Object.keys(datatoFilter).forEach((id) => {
        if (!colunas.includes(Number(id))) {
            const columnData = datatoFilter[id];
            // Copy the full data for non-filtered columns
            newFilteredData[id] = {
                column_name: columnData.column_name,
                data: columnData.data,
                row_id: columnData.row_id,
            };
        }
    });

    return newFilteredData;
}

const handleDropdownChange = (columnId, selectedValue) => {

  const updatedSelections = {
    ...this.state.dropdownSelections,
    [columnId]: selectedValue
  };

    let filtered = tableColumnData;
    Object.entries(updatedSelections).forEach(([key, value]) => {
    if (value) filtered = filterTableData(key, value, filtered);
    });

this.setState({ dropdownSelections: updatedSelections });
this.setState({ filteredData: filtered });
  };

const getUniqueValues = (columnId) => {
    const columnData = tableColumnData[columnId];
    if (columnData) {
      return [...new Set(columnData.data)]; // Extract unique values
    }
    return []; // Return an empty array if the column does not exist
  };

  function getColumnIds(labelIds) {
    const columnIds = Object.values(tables).flatMap(table =>
        table.columns.some(column => labelIds.includes(column.column_id))
            ? table.columns.map(column => column.column_id)
            : []
    );
    return columnIds;
}

    const widgetIds = dashboard.widgets.map(widget => widget.widget_id);
    const labelIds = widgetIds
  .filter(widgetId => widgets[widgetId])
  .map(widgetId => widgets[widgetId].label_id);

const showMessage = Object.keys(this.state.widgets_data).length === 0;

const { isElementosVisible, isWidgetsVisible, isTemasVisible, isFiltrosVisible } = this.state;

const widgetIdsInData = new Set(Object.keys(this.state.widgets_data));

const unusedWidgets = Object.fromEntries(
  Object.entries(widgets).filter(([widgetId, widget]) => !widgetIdsInData.has(widgetId))
);

const nonElementWidgets = Object.keys(unusedWidgets)
    .filter(key => unusedWidgets[key].label_id !== 0)
    .reduce((result, key) => {
        result[key] = unusedWidgets[key];
        return result;
    }, {});

const toggleSelection = (widgetId) => {
  this.setState(prevState => ({
    selectedWidgetIds: prevState.selectedWidgetIds.includes(widgetId)
      ? prevState.selectedWidgetIds.filter(id => id !== widgetId) // Remove if already selected
      : [...prevState.selectedWidgetIds, widgetId] // Add if not selected
  }));
};

    return (
      <>
{renderAutoSaveModal(
  this.state.isConfirmationModalOpen,
  "As alterações são guardadas automaticamente",
  "Qualquer alteração feita neste dashboard será guardada de imediato. Se quiser experimentar alterações sem afetar a versão atual, duplique o dashboard para criar uma cópia.",
  () => {
    localStorage.setItem("seenAutoSaveModal", "true");
    this.setState({ isConfirmationModalOpen: false });
  },
  () => {
    this.setState({ isConfirmationModalOpen: false });
  }
)}
      <div className="project-info">
      <span>{""}</span>
      <div className="icons-container">

{permission !== "URL" && (<>
     <div className="compact-buttons">

<div
  className="tooltip"
  data-tooltip="Alinhar elementos à esquerda"
>
  <button
    className={`compact-btn ${this.state.compactType === "horizontal" ? "selected" : ""} ${permission === "read-only" || !this.state.isDraggable ? "disabled" : ""}`}
      onClick={() => {
      if (permission === "read-only") return;
      this.setState({ compactType: "horizontal" });
    }}
    disabled={permission === "read-only" || !this.state.isDraggable}
  >
    {/* Horizontal Icon */}
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M4 4L4 20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <rect x="7" y="6" width="13" height="4" rx="2" stroke="currentColor" stroke-width="2"/>
  <rect x="7" y="14" width="9" height="4" rx="2" stroke="currentColor" stroke-width="2"/>
</svg>
  </button>
</div>

<div
  className="tooltip"
  data-tooltip="Alinhar elementos ao topo"
>
  <button
    className={`compact-btn ${this.state.compactType === "vertical" ? "selected" : ""} ${permission === "read-only" || !this.state.isDraggable ? "disabled" : ""}`}
      onClick={() => {
      if (permission === "read-only") return;
      this.setState({ compactType: "vertical" });
    }}
    disabled={permission === "read-only" || !this.state.isDraggable}
  >
    {/* Align Top Icon */}
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M4 4H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <rect x="6" y="8" width="12" height="4" rx="2" stroke="currentColor" stroke-width="2"/>
  <rect x="6" y="14" width="8" height="4" rx="2" stroke="currentColor" stroke-width="2"/>
</svg>
  </button>
</div>

<div
  className="tooltip"
  data-tooltip="Movimentação livre dos elementos"
>
  <button
    className={`compact-btn ${this.state.compactType === null ? "selected" : ""} ${permission === "read-only" || !this.state.isDraggable ? "disabled" : ""}`}
      onClick={() => {
      if (permission === "read-only") return;
      this.setState({ compactType: null });
    }}
    disabled={permission === "read-only" || !this.state.isDraggable}
  >
    {/* New Icon (Grid) */}
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12 2V22" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <path d="M2 12H22" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <path d="M8 6L12 2L16 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M18 8L22 12L18 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M16 18L12 22L8 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6 16L2 12L6 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  </button>
</div>
</div>

<button
  className={`lockButton ${permission === "read-only" ? "disabled" : ""}`}
  onClick={() => {
    if (permission === "read-only") return;

    this.setState((prevState) => ({
      isDraggable: !prevState.isDraggable
    }));
  }}
  disabled={permission === "read-only"}
>
  <span className="lockContent">
    {permission === "read-only" || !this.state.isDraggable ? (<LockIcon />) : (<UnlockIcon/>)}
    {permission === "read-only"
      ? "Elementos Bloqueados"
      : this.state.isDraggable
        ? "Elementos Desbloqueados"
        : "Elementos Bloqueados"}
  </span>
</button>
  </>)}
            </div>
            </div>

      <div className="main-content2">
{((permission !== "read-only") && (permission !== "URL")) && (

        <div className="sidebar2">
{/*------------------------------------------------------------------------------------*/}
      <div className="category2">
        <h3 onClick={() => {
    this.setState(prevState => ({ isElementosVisible: !prevState.isElementosVisible }));
  }} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', borderBottom: '1px solid #233C7E40' }}>
          <SideDashHeading style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Elementos
          {isElementosVisible ? (
  <SideDashUp style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
) : (
  <SideDashDown style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
)}
        </h3>
        {isElementosVisible && (
  <div className="scrollable-content">
  {['Parágrafo', 'Título', 'Imagem', 'Subtitulo'].map((name, index) => (
    <div
      key={`category1-${index}`}
      className="droppable-element2"
      draggable={true}
      unselectable="on"
      onDragStart={(e) => e.dataTransfer.setData('elementType', name)} // Updated line
    >
      {name}
    </div>
  ))}
</div>
)}
      </div>
{/*------------------------------------------------------------------------------------*/}
      <div className="category2">
        <h3
        onClick={() => {
    this.setState(prevState => ({ isWidgetsVisible: !prevState.isWidgetsVisible }));
  }}

  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', borderBottom: '1px solid #233C7E40' }}>
          <SideDashChart style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Widgets
          {isWidgetsVisible ? (
  <SideDashUp style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
) : (
  <SideDashDown style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
)}
        </h3>
        {isWidgetsVisible && (
          <div className="scrollable-content">
            {Object.entries(nonElementWidgets).map(([widget_id, widget], index) => (
  <div
    key={`category2-${index}`}
    className="droppable-element2"
    draggable={true}
    unselectable="on"
    onDragStart={(e) => {
      this.setState({ isDragging: true });
      e.dataTransfer.setData('widget_id', widget_id);
      e.dataTransfer.setData('elementType', 'newWidget');
    }}
  >
    {widget.name}
  </div>
))}
          </div>
        )}
      </div>
{/*------------------------------------------------------------------------------------*/}
<div className="category2">
        <h3
          onClick={() => {this.setState(prevState => ({ isTemasVisible: !prevState.isTemasVisible }));}}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', borderBottom: '1px solid #233C7E40' }}>
          <SideDashPalette style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Temas
          {isTemasVisible ? (
  <SideDashUp style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
) : (
  <SideDashDown style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
)}
        </h3>
        {isTemasVisible && (
  <div className="scrollable-content">
    {Object.entries(themeMap).map(([themeNumber, { name, ...styles }]) => (
  <div
    key={themeNumber}
    className="temas-button"
    onClick={() => {
  if (!this.state.lastClickedWidgetId) return;

  const widgetId = this.state.lastClickedWidgetId;

  saveWidgetThemeToDatabase(this.props.DashboardId, widgetId, themeNumber)
      .then(() => {
        // 🔥 refetch widgets so props update
      fetchData(
  `${API_BASE_URL}/dashboards/${this.props.projectId}`,
  this.props.setDashboards,
  this.props.setIsDashboardsLoaded,
  'dashboardData'
);
      })
      .catch(err => {
        console.error("Error saving theme:", err);
      });


}}
  >
    {themeNumber !== "1" && (
      <div
        className="tema-swatch"
        style={{
          backgroundColor: styles.backgroundColor,
          border: styles.border
        }}
      />
    )}
    <span className="tema-name">{name}</span>
  </div>
))}
  </div>
)}
      </div>
{/**************************************************************/}
      <div className="category2">
        <h3
          onClick={() => {this.setState(prevState => ({ isFiltrosVisible: !prevState.isFiltrosVisible }));}}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', borderBottom: '1px solid #233C7E40' }}>
          <SideDashFilters style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Filtros
          {isFiltrosVisible ? (
  <SideDashUp style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
) : (
  <SideDashDown style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
)}
        </h3>
        {isFiltrosVisible && (
    <div className="scrollable-content">
      {getColumnIds(labelIds).map(columnId => (
         <div
              key={columnId}
              onClick={() => toggleSelection(columnId)}
              className="droppable-element2"
              style={{
                cursor: 'pointer', // Change cursor to indicate clickable item
                backgroundColor: this.state.selectedWidgetIds.includes(columnId) ? '#e0e0e0' : 'transparent', // Background color for selected items
                border: this.state.selectedWidgetIds.includes(columnId) ? '1px solid #007bff' : '1px solid transparent', // Border for selected items
                borderRadius: '4px', // Rounded corners for all items
                transition: 'background-color 0.3s, border 0.3s' // transition effect
              }}
            >
              {tableColumnData[columnId]?.column_name}
            </div>
      ))}
    </div>
  )}
      </div>
{/**************************************************************/}
{this.state.selectedWidgetIds.length > 0 && (
  <div className="dropdown-filter-container">
    {this.state.selectedWidgetIds.map(columnId => (
      <div key={columnId} className="dropdown-filter-item">
        <label htmlFor={`dropdown-${columnId}`}>
          {tableColumnData[columnId]?.column_name}
        </label>
        <select
          id={`dropdown-${columnId}`}
          onChange={(e) => handleDropdownChange(columnId, e.target.value)}
        >
          <option value="">Selecionar</option>
          {getUniqueValues(columnId).map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    ))}
  </div>
)}

    </div>
)}
          <div className="dashboard2">
        <div style={{ position: 'relative', height: '455px' }}>
{showMessage && (
<div className="empty-message">
          <HandIcon/>
            Arraste e solte elemento para aqui
          </div>
        )}
        <ResponsiveReactGridLayout
          {...this.props}
          layouts={this.state.layouts}
          onBreakpointChange={this.onBreakpointChange}
          onLayoutChange={this.onLayoutChange}
          onDrop={this.onDrop}
          onDropDragOver={this.onDropDragOver}
          measureBeforeMount={false}
          // animate on mount. If you don't, delete `useCSSTransforms` (it's default `true`)
          // and set `measureBeforeMount={true}`.
          useCSSTransforms={this.state.mounted}
          compactType={this.state.compactType}
          preventCollision={false}
          rowHeight={49}
          cols={{ lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }}
          isDroppable={true}
          isDraggable={this.state.isDraggable}
          isResizable={this.state.isDraggable}
        >
          {this.generateDOM(nonElementWidgets)}
        </ResponsiveReactGridLayout>
        </div>
      </div>
      </div>
      </>
    );
  }
}
//---------------------------- OPTIMIZED -------------------------------

function generateLayout(widgets_data) {

  return Object.keys(widgets_data).map((widgetId, index) => {
    const widget = widgets_data[widgetId];
    const widgetKey = Object.keys(widget)[0];

    return {
      x: widget[widgetKey].x,
      y: widget[widgetKey].y,
      w: widget[widgetKey].w,
      h: widget[widgetKey].h,
      i: widgetId,
      resizeHandles: ["sw", "nw", "se"],
      static: false
    };
  });
}

function WidgetsData(dashboard, widgets) {

  let widgets_data = {};
  for (let widget of dashboard.widgets) {
    if (widget.widget_id !== null) {
      widgets_data[widget.widget_id] = {
        widget_id: {
          ...widgets[widget.widget_id],
          x: widget.x,
          y: widget.y,
          w: widget.w,
          h: widget.h
        }
      };
    }
  }
  return widgets_data;
}

function getWidgetStyle(widgetId, lastClickedWidgetId, widgetThemes, permission) {
  const theme = themeMap[widgetThemes[widgetId] || 1];

  const shouldHighlight =
    permission !== "URL" && lastClickedWidgetId === widgetId;

  return {
    border: theme.border,
    backgroundColor: theme.backgroundColor,
    color: theme.color,
    boxShadow: shouldHighlight
      ? "0 0 19.1px 0 rgba(35, 60, 126, 0.7)"
      : "none",
  };
}
